import { IconFile } from '../components/icons';
import { ModuleHeader, useAsync } from '../components/ui';
import { api } from '../lib/api';
import { InvoicesPanel } from './material/InvoicesPanel';

/**
 * Eingangsrechnungen (Kap. 7) – vormals ein Register unter „Material &
 * Lagerwirtschaft“, jetzt eine eigene Seite, weil Rechnungsprüfung und
 * -buchung ein eigenständiger Arbeitsschritt ist, keine Lagerverwaltung.
 */
export function InvoicesPage() {
  const warehouses = useAsync(() => api.get('/api/material/warehouses'), []);

  return (
    <div className="stack">
      <ModuleHeader
        icon={<IconFile width={22} height={22} />}
        title="Eingangsrechnungen"
        subtitle={
          <>
            Lieferantenrechnungen erfassen, prüfen und je Position auf Lager buchen. Erfassen und Buchen sind
            bewusst getrennt: Eine Rechnung darf geprüft und korrigiert werden, ohne dass jeder Zwischenstand
            schon Lagerbestand erzeugt.
          </>
        }
        pill="Lagerwirtschaft"
        tone="warning"
      />

      <InvoicesPanel warehouses={warehouses.data ?? []} />
    </div>
  );
}
